//
// Copyright (c) 2021 Astute Global, Inc.
//

// @ts-ignore
import i18next from "i18n/i18n";
import ContentMappingModule from "modules/shared/contentMapping/contentMappingModule";
import MarionetteView from "../../marionetteView";
import { uid } from "ckeditor5";
import Messenger from "messaging/messenger";

import "../css/contentMappingSelect.css";

export default class ContentMappingSelect extends MarionetteView {
  constructor(locale) {
    super(locale);
    this.set("contentMappingId", null);
    this.set("contentMappingName", null);
    this.set("contentMappingUrl", null);
    this.set("errorText", null);
    this.set("languageId", null);
    this.set("namespace", "contentMapping-" + uid());
    this.set("touchPointId", null);
  }

  createModule() {
    return new ContentMappingModule({
      region: this.region,
      namespace: this.namespace,
    });
  }

  getClasses() {
    return ["content-mapping-select", ...super.getClasses()];
  }

  showModule() {
    return this.module.show();
  }

  setUpVents() {
    Messenger.vent.on(
      Messenger.getFullName("list:item:selected", this.namespace),
      this._onContentMappingSelect,
      this,
    );
    Messenger.vent.on(
      Messenger.getFullName("mapping:search:selected", this.namespace),
      this._onContentMappingSelect,
      this,
    );
  }

  tearDownVents() {
    Messenger.vent.off(
      Messenger.getFullName("list:item:selected", this.namespace),
      this._onContentMappingSelect,
      this,
    );
    Messenger.vent.off(
      Messenger.getFullName("mapping:search:selected", this.namespace),
      this._onContentMappingSelect,
      this,
    );
  }

  _onContentMappingSelect(model) {
    const languageId = this.languageId;
    const touchPointId = this.touchPointId;
    const urls = model.urls();
    urls.onSynced(() => {
      let href = "";
      urls.each((url) => {
        if (url.get("touchpointId") == touchPointId && url.get("languageId") == languageId) {
          href = url.get("url");
        }
      });
      if (!href) {
        this.set("errorText", i18next.t("ckeditor.contentMapping.undefinedUrl"));
      } else {
        this.set("errorText", "");
        this.set("contentMappingId", model.id);
        this.set("contentMappingName", model.get("name"));
        this.set("contentMappingUrl", href);
        this.fire("contentMapping:select", model, href);
      }
    });
  }
}
